import { useState } from 'react';
import { ColorButton } from '../../UI';
import { COLORS } from '../../../constants/colors';
import { DropdownMenu } from '../';

export interface ColorPickerProps {
  onChange?: any;
  selectedColor?: keyof typeof COLORS;
  display?: 'list' | 'dropdown';
}

export const ColorPicker = ({
  selectedColor,
  onChange,
  display = 'list',
}: ColorPickerProps) => {
  const [selectedColorState, setSelectedColorState] = useState(selectedColor);

  const handleChange = (color) => {
    setSelectedColorState(color);

    if (onChange) {
      onChange(color);
    }
  };

  return display === 'list' ? (
    <div className="flex items-center gap-6 lg:gap-10 justify-between">
      {Object.keys(COLORS).map((color, index) => (
        <ColorButton
          key={color + '_' + index}
          color={color}
          isSelected={color === selectedColorState}
          onClick={handleChange}
          isGroup={true}
        />
      ))}
    </div>
  ) : (
    <div className={'inline-flex'}>
      <DropdownMenu
        dropdownClassName={''}
        dropdownIconClassName="relative"
        dropdownTooltipClassName={`bg-white border-solid border-grey-10 rounded-lg border shadow-md z-80 w-max`}
        dropdownItems={['']}
        dropdownItemsComponents={[
          <div className={'grid grid-cols-4 p-4 gap-4'}>
            {Object.keys(COLORS).map((color, index) => (
              <ColorButton
                key={color + '_' + index}
                color={color}
                isSelected={color === selectedColorState}
                onClick={handleChange}
                isGroup={true}
              />
            ))}
          </div>,
        ]}
        setDropdownAsStatic
        hideOnItemClick
        hideOnOutsideClick
      >
        <ColorButton
          color={selectedColorState || Object.keys(COLORS)[0]}
          isSelected={false}
          isReadOnly={true}
        />
      </DropdownMenu>
    </div>
  );
};
